/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HealthFindrBaseService } from '../health-findr-base-service';
import { HealthFindrApiConfiguration } from '../health-findr-api-configuration';
import { HealthFindrStrictHttpResponse } from '../health-findr-strict-http-response';

import { termsConditionsIdDelete } from '../fn/terms-conditions/terms-conditions-id-delete';
import { TermsConditionsIdDelete$Params } from '../fn/terms-conditions/terms-conditions-id-delete';
import { termsConditionsIdGet } from '../fn/terms-conditions/terms-conditions-id-get';
import { TermsConditionsIdGet$Params } from '../fn/terms-conditions/terms-conditions-id-get';
import { TermsConditionsModel } from '../models/terms-conditions-model';
import { termsConditionsSavePost } from '../fn/terms-conditions/terms-conditions-save-post';
import { TermsConditionsSavePost$Params } from '../fn/terms-conditions/terms-conditions-save-post';
import { termsConditionsSearchPost } from '../fn/terms-conditions/terms-conditions-search-post';
import { TermsConditionsSearchPost$Params } from '../fn/terms-conditions/terms-conditions-search-post';
import { TermsConditionsSearchResultModel } from '../models/terms-conditions-search-result-model';

@Injectable({ providedIn: 'root' })
export class HealthFindrTermsConditionsService extends HealthFindrBaseService {
  constructor(config: HealthFindrApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `termsConditionsSearchPost()` */
  static readonly TermsConditionsSearchPostPath = '/TermsConditions/Search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsConditionsSearchPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  termsConditionsSearchPost$Response(params?: TermsConditionsSearchPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<TermsConditionsSearchResultModel>>> {
    return termsConditionsSearchPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsConditionsSearchPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  termsConditionsSearchPost(params?: TermsConditionsSearchPost$Params, context?: HttpContext): Observable<Array<TermsConditionsSearchResultModel>> {
    return this.termsConditionsSearchPost$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<TermsConditionsSearchResultModel>>): Array<TermsConditionsSearchResultModel> => r.body)
    );
  }

  /** Path part for operation `termsConditionsIdGet()` */
  static readonly TermsConditionsIdGetPath = '/TermsConditions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsConditionsIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsConditionsIdGet$Response(params: TermsConditionsIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<TermsConditionsModel>> {
    return termsConditionsIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsConditionsIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsConditionsIdGet(params: TermsConditionsIdGet$Params, context?: HttpContext): Observable<TermsConditionsModel> {
    return this.termsConditionsIdGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<TermsConditionsModel>): TermsConditionsModel => r.body)
    );
  }

  /** Path part for operation `termsConditionsIdDelete()` */
  static readonly TermsConditionsIdDeletePath = '/TermsConditions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsConditionsIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsConditionsIdDelete$Response(params: TermsConditionsIdDelete$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
    return termsConditionsIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsConditionsIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsConditionsIdDelete(params: TermsConditionsIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.termsConditionsIdDelete$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `termsConditionsSavePost()` */
  static readonly TermsConditionsSavePostPath = '/TermsConditions/Save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsConditionsSavePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  termsConditionsSavePost$Response(params?: TermsConditionsSavePost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<string>> {
    return termsConditionsSavePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsConditionsSavePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  termsConditionsSavePost(params?: TermsConditionsSavePost$Params, context?: HttpContext): Observable<string> {
    return this.termsConditionsSavePost$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<string>): string => r.body)
    );
  }

}
